import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import POS from "@/pages/POS";
import Wholesale from "@/pages/Wholesale";
import DailyRates from "@/pages/DailyRates";
import Purchases from "@/pages/Purchases";
import Products from "@/pages/Products";
import Customers from "@/pages/Customers";
import Reports from "@/pages/Reports";
import Insights from "@/pages/Insights";
import Receivables from "@/pages/Receivables";
import Payables from "@/pages/Payables";
import Expenses from "@/pages/Expenses";
import PartyOrders from "@/pages/PartyOrders";
import Suppliers from "@/pages/Suppliers";
import FreezerInOut from "@/pages/FreezerInOut";
import FreezerStock from "@/pages/FreezerStock";
import FreezerAnalytics from "@/pages/FreezerAnalytics";
import PaperRates from "@/pages/PaperRates";
import Settings from "@/pages/Settings";
import LockScreen from "@/pages/LockScreen";
import { AuthProvider, useAuth, isPathAllowedForRole } from "@/lib/auth";

const StaffHome = () => <Navigate to="/pos" replace />;

const Guard = ({ path, owner = false, children }) => {
  const { role } = useAuth();
  if (owner && role !== "owner") return <StaffHome />;
  if (!isPathAllowedForRole(path, role)) return <StaffHome />;
  return children;
};

function Shell() {
  const { role } = useAuth();
  if (!role) return <LockScreen />;
  return (
    <Layout>
      <Routes>
        <Route
          path="/"
          element={
            role === "owner" ? <Dashboard /> : <Navigate to="/pos" replace />
          }
        />
        <Route path="/pos" element={<POS />} />
        <Route path="/wholesale" element={<Wholesale />} />
        <Route path="/party-orders" element={<PartyOrders />} />
        <Route path="/suppliers" element={<Guard path="/suppliers" owner>{<Suppliers />}</Guard>} />
        <Route path="/rates" element={<Guard path="/rates" owner>{<DailyRates />}</Guard>} />
        <Route path="/paper-rates" element={<Guard path="/paper-rates" owner>{<PaperRates />}</Guard>} />
        <Route path="/purchases" element={<Guard path="/purchases" owner>{<Purchases />}</Guard>} />
        <Route path="/expenses" element={<Guard path="/expenses" owner>{<Expenses />}</Guard>} />
        <Route path="/freezer-stock" element={<Guard path="/freezer-stock" owner>{<FreezerStock />}</Guard>} />
        <Route path="/freezer-inout" element={<Guard path="/freezer-inout" owner>{<FreezerInOut />}</Guard>} />
        <Route path="/freezer-analytics" element={<Guard path="/freezer-analytics" owner>{<FreezerAnalytics />}</Guard>} />
        <Route path="/products" element={<Guard path="/products" owner>{<Products />}</Guard>} />
        <Route path="/customers" element={<Guard path="/customers" owner>{<Customers />}</Guard>} />
        <Route path="/receivables" element={<Guard path="/receivables" owner>{<Receivables />}</Guard>} />
        <Route path="/payables" element={<Guard path="/payables" owner>{<Payables />}</Guard>} />
        <Route path="/reports" element={<Guard path="/reports" owner>{<Reports />}</Guard>} />
        <Route path="/insights" element={<Guard path="/insights" owner>{<Insights />}</Guard>} />
        <Route path="/settings" element={<Guard path="/settings" owner>{<Settings />}</Guard>} />
        <Route path="*" element={<Navigate to={role === "owner" ? "/" : "/pos"} replace />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Shell />
          <Toaster
            position="top-right"
            toastOptions={{
              style: {
                borderRadius: 0,
                border: "1px solid #e4e4e7",
              },
            }}
          />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
